// Gestores (7-oct-2026). «Propietario y liquidación» (components/Gestores/OwnerSettlementPanel.vue
// y su modal OwnerFormModal.vue): la tarjeta del anuncio donde el gestor dice para quién lo lleva,
// quién cobra y cómo se le liquida.
export const ownerSettlement = {
  head: {
    title: "Propriétaire et reversements",
    sub: "Si vous gérez cet hébergement pour un autre propriétaire, définissez qui encaisse, votre commission et comment vous lui reversez sa part. Ses reversements et vos analyses de gestion en dépendent.",
  },
  loading: "Chargement des réglages…",
  loadError: {
    title: "Impossible de charger les réglages",
    text: "Vérifiez votre connexion et réessayez.",
    retry: "Réessayer",
  },
  master: {
    label: "Je gère cet hébergement pour un propriétaire",
    hintOff: "L'hébergement vous appartient : ses réservations comptent comme vos propres revenus.",
    hintOn: "Ses réservations sont reversées au propriétaire selon les conditions ci-dessous.",
    kept: "Vos conditions sont conservées au cas où vous le réactiveriez.",
    introTitle: "Une fois activé :",
    intro1: "Vous choisissez le propriétaire et qui encaisse les réservations.",
    intro2: "Vous fixez votre commission, sa TVA et à qui revient le ménage.",
    intro3: "Vous voyez aussitôt à quoi ressemble son reversement.",
  },
  owner: {
    title: "Propriétaire",
    hint: "La personne ou la société à qui vous reversez les revenus de cet hébergement.",
    placeholder: "Choisissez un propriétaire",
    new: "Nouveau propriétaire",
    add: "Ajouter un propriétaire",
    edit: "Modifier",
    emptyTitle: "Vous n'avez pas encore de propriétaires",
    emptyText: "Ajoutez le propriétaire de cet hébergement pour pouvoir lui reverser sa part.",
    missing: "Sans propriétaire attribué, les reversements de cet hébergement n'auront pas de destinataire.",
    pending: "Attribué à l'enregistrement",
    taxId: "N° fiscal",
    addTaxId: "Ajouter le n° fiscal",
    iban: "IBAN",
    addIban: "Ajouter l'IBAN",
  },
  ownerForm: {
    titleNew: "Nouveau propriétaire",
    titleEdit: "Modifier le propriétaire",
    sub: "Ses coordonnées figurent sur les reversements des hébergements que vous gérez pour lui.",
    close: "Fermer",
    name: "Nom ou raison sociale",
    taxId: "N° fiscal / SIRET",
    taxIdHint: "Son numéro d'identification fiscale, quel que soit le pays.",
    taxIdDoubt: "S'il s'agit d'un NIF espagnol, le caractère de contrôle ne correspond pas. S'il vient d'un autre pays, ignorez cet avis.",
    email: "E-mail",
    phone: "Téléphone",
    iban: "IBAN",
    ibanPlaceholder: "FR76 0000 0000 0000 0000 0000 000",
    ibanHint: "Le compte sur lequel vous lui virez sa part.",
    ibanOk: "IBAN valide · {country}",
    address: "Adresse",
    notes: "Notes",
    notesPlaceholder: "Ce que vous avez convenu, le jour de paiement…",
    sharedNote: "Il est aussi propriétaire de {n} autre hébergement : les modifications s'y appliqueront. | Il est aussi propriétaire de {n} autres hébergements : les modifications s'appliqueront à tous.",
    cancel: "Annuler",
    save: "Enregistrer le propriétaire",
    saving: "Enregistrement…",
    created: "Propriétaire créé",
    updated: "Propriétaire mis à jour",
    deleted: "Propriétaire supprimé",
    errName: "Saisissez le nom ou la raison sociale.",
    errEmail: "Vérifiez l'e-mail : il ne semble pas valide.",
    errIbanFormat: "Un IBAN commence par le code du pays et deux chiffres de contrôle (FR76…).",
    errIbanCheck: "Les chiffres de contrôle ne correspondent pas : vérifiez qu'il est bien copié.",
    errIbanLength: "Un IBAN ({country}) compte {expected} caractères ; celui-ci en compte {actual}.",
    errSave: "Impossible d'enregistrer le propriétaire. Réessayez.",
    errDelete: "Impossible de supprimer le propriétaire. Réessayez.",
    delete: "Supprimer le propriétaire",
    deleteTitle: "Supprimer {name} ?",
    deleteText: "Il disparaîtra de votre liste de propriétaires. Cette action est irréversible.",
    deleteConfirm: "Supprimer",
    deleteBlocked: "Suppression impossible : il est propriétaire de {n} hébergement. Retirez-le d'abord. | Suppression impossible : il est propriétaire de {n} hébergements. Retirez-le d'abord de chacun.",
    discardTitle: "Abandonner les modifications ?",
    discardText: "Ce que vous avez saisi pour ce propriétaire sera perdu.",
    discardConfirm: "Abandonner",
    discardCancel: "Continuer",
  },
  units: {
    title: "Propriétaire de chaque logement",
    hint: "Si un logement appartient à quelqu'un d'autre, choisissez-le ici. Les autres sont reversés au propriétaire de l'annonce.",
    inherit: "Celui de l'annonce",
    summaryNone: "Tous appartiennent au propriétaire de l'annonce",
    summarySome: "{n} logement avec un autre propriétaire | {n} logements avec un autre propriétaire",
  },
  collection: {
    title: "Qui encaisse les réservations ?",
    hint: "Cela change où va l'argent, pas ce qui reste au propriétaire.",
    ownerLabel: "Le propriétaire encaisse",
    ownerDesc: "Les plateformes et votre site paient le propriétaire. Ensuite, il vous règle votre facture d'honoraires (et le ménage, s'il vous revient).",
    managerLabel: "Le gestionnaire encaisse",
    managerDesc: "L'argent des réservations vous parvient. Vous gardez votre part et lui reversez la sienne.",
    flowBooking: "Réservation",
    flowOwner: "Propriétaire",
    flowYou: "Vous",
  },
  commission: {
    title: "Votre commission",
    percent: "Taux de commission",
    vat: "TVA sur votre commission",
    base: "Calculée sur",
    presetTotal: "Total de la réservation",
    presetAccommodation: "Hébergement hors ménage",
    presetNet: "Net après commission OTA",
    presetDescNet: "{concepts}, moins leur part de la commission OTA",
    presetNetClean: "Net of OTA and cleaning",
    presetDescNetClean: "What the owner keeps before your fee: the total minus the OTA, its VAT and cleaning",
    exampleBase: "base dans l'exemple",
    custom: "Personnalisé",
    customize: "Ajuster à la main",
    baseLabel: "Sur quel montant",
    gross: "Ce que paie le client",
    net: "Ce qui reste après la commission OTA",
    netClean: "What's left after the OTA and cleaning",
    concepts: "Éléments inclus",
    warnTaxes: "Les taxes ne sont pas des revenus : on ne prend généralement pas de commission dessus.",
    fixTaxes: "Retirer les taxes",
    warnCleaning: "Vous prenez une commission sur un ménage que vous gardez déjà.",
    fixCleaning: "Retirer le ménage",
    warnDeposit: "La caution est rendue au client : on ne prend généralement pas de commission dessus.",
    fixDeposit: "Retirer la caution",
    errPercent: "Indiquez un pourcentage entre 0 et 100.",
    errConcepts: "Choisissez au moins un élément.",
  },
  concepts: {
    accommodation: "Hébergement",
    cleaning: "Ménage",
    taxes: "Taxes",
    extras: "Extras",
    deposit: "Caution",
  },
  // Los mismos conceptos dentro de una frase («Base: alojamiento y extras.»)
  conceptsInline: {
    accommodation: "hébergement",
    cleaning: "ménage",
    taxes: "taxes",
    extras: "extras",
    deposit: "caution",
  },
  cleaning: {
    title: "Ménage",
    hint: "Qui garde ce que paie le client pour le ménage ?",
    owner: "Il revient au propriétaire",
    ownerDesc: "Il reste dans son net : rien n'est déduit.",
    manager: "Il vous revient",
    managerDesc: "Vous vous en chargez et il est déduit de la part du propriétaire.",
    charged: "Ce que paie le client pour le ménage",
    fixed: "Un montant fixe par séjour",
    fixedAmount: "Montant par séjour",
    fixedHint: "Si une réservation comprend plusieurs chambres, il est compté une fois par chambre.",
    errAmount: "Indiquez le montant fixe du ménage par séjour.",
  },
  ota: {
    title: "Commission de chaque OTA",
    moved: "Le % de chaque OTA se règle dans la carte « {card} ».",
    open: "Ouvrir « {card} »",
  },
  example: {
    title: "Reversement d'exemple",
    sub: "Une réservation {channel} de {total}, avec vos conditions actuelles.",
    guest: "Ce que paie le client",
    platform: "Ce que garde {channel}",
    platformNote: "Sa commission : {pct}\u00a0% de {base} ({concepts}).",
    platformYours: "Vos % de « {card} » l'emportent, même si {channel} envoie sa commission.",
    platformReal: "Si {channel} envoie la commission d'une réservation, c'est elle qui compte.",
    platformRule: "Si vous indiquez le % de {channel} dans « {card} », le vôtre l'emporte ; sinon, sa commission.",
    otaVat: "TVA sur la commission {channel} ({pct}\u00a0%)",
    changeIn: "Modifier dans « {card} »",
    changeWhere: "Se modifie dans « {card} ».",
    notOwner: "Ce qui ne revient pas au propriétaire",
    taxes: "Taxes et impôts",
    taxesNote: "Ce ne sont pas des revenus du propriétaire.",
    cleaning: "Ménage que vous gardez",
    cleaningNoteCharged: "Ce que paie le client pour le ménage.",
    cleaningNoteFixed: "Votre montant fixe par séjour.",
    fees: "Vos honoraires de gestion",
    commission: "Commission : {pct} % de {base}",
    commissionBase: "Base : {concepts}.",
    commissionBaseNet: "Base : {concepts}, moins leur part de la commission {channel}.",
    commissionBaseNetClean: "Base: what the owner keeps after {channel}, its VAT and cleaning.",
    vat: "TVA sur votre commission ({pct} %)",
    invoice: "Total de votre facture d'honoraires",
    net: "Net pour le propriétaire",
    netNote: "Ce qui lui revient sur cette réservation.",
    netNegative: "Les déductions dépassent ce que laisse la réservation.",
    splitTitle: "Répartition des {total}",
    legendTaxes: "Taxes",
    legendCleaning: "Ménage (le vôtre)",
    legendFees: "Vos honoraires",
    legendOwner: "Propriétaire",
    legendDeficit: "Manque",
    transferTitle: "Vous lui reversez {amount}",
    transferTitleTo: "Vous reversez {amount} à {owner}",
    transferInvoice: "Et vous émettez votre facture d'honoraires de {amount}.",
    owesTitle: "Le propriétaire vous doit {amount}",
    owesTitleFrom: "{owner} vous doit {amount}",
    owesInvoice: "Rien à reverser. Votre facture d'honoraires s'élève à {amount}.",
    owesHint: "Dans cet exemple, les déductions dépassent ce que laisse la réservation.",
    collectTitle: "Le propriétaire vous paie {amount}",
    collectTitleFrom: "{owner} vous paie {amount}",
    collectBreakdown: "C'est votre facture d'honoraires ({fees}).",
    collectBreakdownCleaning: "Votre facture d'honoraires ({fees}) plus le ménage ({cleaning}).",
    ownerLoses: "Avec ces conditions, le propriétaire perd {amount} sur cette réservation.",
    foot: "Montants d'exemple. Le reversement réel utilise le détail de chaque réservation.",
    footNoOtaVat: "Sans la TVA sur la commission de l'OTA.",
  },
  footer: {
    save: "Enregistrer les modifications",
    saving: "Enregistrement…",
    unsaved: "Modifications non enregistrées",
    saved: "Enregistré",
    fixErrors: "Vérifiez les champs signalés.",
    errSave: "Impossible d'enregistrer. Réessayez.",
    peekLabel: "Reste au propriétaire",
    peekAria: "Voir le reversement d'exemple : il reste {amount} au propriétaire",
  },
};
